import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form profile-form"
}
const _hoisted_3 = { class: "card p-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BillingInfoModal = _resolveComponent("BillingInfoModal")!

  return (_ctx.isStillLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_font_awesome_icon, {
          icon: ['fa', 'fa-spinner'],
          class: "fs-1"
        })
      ]))
    : (_openBlock(), _createElementBlock("form", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", null, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'file-invoice'],
              class: "d-inline-block me-1"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.language.billing_info), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("dl", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.language.my_curr_plan), 1),
            _createElementVNode("dd", null, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.language.plan_msg_crt), 1),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showBillingPlanInfo && _ctx.showBillingPlanInfo(...args)))
                  }, _toDisplayString(_ctx.language.change_plan), 1)
                ])
              ])
            ]),
            _createElementVNode("dt", null, _toDisplayString(_ctx.language.cred_card), 1),
            _createElementVNode("dd", null, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString((_ctx.connectedUser) ? (_ctx.connectedUser.FirstName + ' ' + _ctx.connectedUser.LastName) : ''), 1),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCreditCardInfo && _ctx.showCreditCardInfo(...args)))
                  }, _toDisplayString(_ctx.language.change_card), 1)
                ])
              ])
            ]),
            _createElementVNode("dt", null, _toDisplayString(_ctx.language.cancel), 1),
            _createElementVNode("dd", null, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelAccount && _ctx.cancelAccount(...args))),
                    class: "btn-xs"
                  }, _toDisplayString(_ctx.language.cancel_acct), 1)
                ])
              ])
            ])
          ])
        ]),
        _hoisted_4,
        (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
          _createVNode(_component_BillingInfoModal, {
            visible: _ctx.isDialogOpen,
            initialValues: _ctx.dialogRecordData,
            recordStatus: _ctx.dialogRecordStatus,
            onCloseForm: _ctx.onCloseForm
          }, null, 8, ["visible", "initialValues", "recordStatus", "onCloseForm"])
        ]))
      ]))
}